/**
 * Mega Menu Grouping Script v4.0
 * Agrupa elementos sin submenús en una sola columna para mejor organización
 */

(function() {
  'use strict';

  function groupMegaMenuElements() {
    const firstMegaMenu = document.querySelector('.m-menu__item--mega[data-index="0"]');
    if (!firstMegaMenu) {
      return;
    }

    const subMenuLevel1 = firstMegaMenu.querySelector('.m-sub-menu--level-1');
    if (!subMenuLevel1) {
      return;
    }

    const existingGrouped = subMenuLevel1.querySelectorAll('.mega-menu-grouped-column');
    if (existingGrouped.length > 0) {
      existingGrouped.forEach(element => element.remove());
    }

    const itemsWithoutSubmenu = subMenuLevel1.querySelectorAll('.m-sub-menu__item--level-1:not(:has(.m-mega-menu__column))');
    
    if (itemsWithoutSubmenu.length === 0) {
      return;
    }

    const groupedColumn = document.createElement('li');
    groupedColumn.className = 'mega-menu-grouped-column m-sub-menu__item--level-1';
    
    const internalList = document.createElement('ul');
    internalList.className = 'mega-menu-grouped-list';

    const elementsData = Array.from(itemsWithoutSubmenu).map(item => {
      const link = item.querySelector('.m-menu__link');
      return {
        href: link ? link.href : '#',
        text: link ? link.textContent.trim() : 'Sin título',
        element: item
      };
    });

    elementsData.forEach((data) => {
      const listItem = document.createElement('li');
      listItem.className = 'mega-menu-grouped-item';
      
      const link = document.createElement('a');
      link.href = data.href;
      link.className = 'm-menu__link mega-menu-grouped-link';
      link.textContent = data.text;
      
      listItem.appendChild(link);
      internalList.appendChild(listItem);
      
      data.element.remove();
    });

    groupedColumn.appendChild(internalList);

    const firstItemWithSubmenu = subMenuLevel1.querySelector('.m-sub-menu__item--level-1:has(.m-mega-menu__column)');
    if (firstItemWithSubmenu && firstItemWithSubmenu.nextElementSibling) {
      subMenuLevel1.insertBefore(groupedColumn, firstItemWithSubmenu.nextElementSibling);
    } else {
      subMenuLevel1.appendChild(groupedColumn);
    }

    window.megaMenuGroupingExecuted = true;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', groupMegaMenuElements);
  } else {
    setTimeout(groupMegaMenuElements, 50);
  }
})();
